

<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
  <span *ngIf="!isEmptyAndNull($.row) &&  $.row[$.adata.KeyName] && $.row[$.adata.KeyName] != '01/01/0001 00:00:00';else dash">
  {{$.row[$.adata.KeyName] | datetimeformat : $.adata.format : hasValue($.adata.applytimezone) ? $.adata.applytimezone: true }}
  </span>
  <ng-template #dash>-</ng-template>

</ng-container>
